import { IMusicMenuState } from "source/app/presentation/Header/Tools/Sound/Music/IMusicMenuState";
import MusicMenu from "source/app/presentation/Header/Tools/Sound/Music/MusicMenu";
import { HowlerSoundFile } from "source/app/services/Sound/HowlerSoundFile";
import { Dictionary } from "../../../../../../motw_core/Utils/Dictionary";
import Data from "../../Data";
import { NonRepeatingShuffledArray } from "../../NonRepeatingShuffledArray";
import StaticSingleton from "../../Shared/StaticSingleton";
import Background from "../../UI/Background/Background";
import { ESharedComponent } from "../../UI/State/ESharedComponent";
import { State } from "../../UI/State/State";
import { B2FileInfo } from "./BackBlazeFilePath";

class Music extends StaticSingleton<Music> {
    async StartNextSong(): Promise<void> {
        const nextSongFileInfo = await this.GetNextSongFileInfo();

        if (!nextSongFileInfo) {
            return;
        }

        this.GetMusicMenu().setState({
            currentFileInfo: nextSongFileInfo,
        });
    }

    GetMusicSoundFile(b2FileInfo: B2FileInfo): HowlerSoundFile {
        const { filePath } = b2FileInfo;
        var musicSoundFile = new HowlerSoundFile(filePath);
        return musicSoundFile;
    }

    Stop(): void {
        const { currentMusicSoundFile } = this.GetMusicMenu().state;

        if (!currentMusicSoundFile) {
            return;
        }

        Background.ChangeImage();
        currentMusicSoundFile.Stop();
        MusicMenu.ClearTransitionTimeout();

        this.GetMusicMenu().setState({
            currentFileInfo: undefined,
            loadingProgressPercent: undefined,
        });
    }

    ExtendedPlaylistMap: Dictionary<string, string[]> = new Dictionary({
        "High Energy": ["Epic", "Gamemaker"],
        "Low Energy": ["Anti Anxiety", "Dawn", "Deep Space", "Hope"],
    });

    ChangeSong() {
        this.Stop();
        this.StartNextSong();
    }

    Duck() {
        const { currentMusicSoundFile } = this.GetMusicMenu().state;

        if (currentMusicSoundFile) {
            console.log(`[Music] Ducking`);
            currentMusicSoundFile.FadeOut(0.3, 400);
        }
    }

    UnDuck() {
        const { currentMusicSoundFile } = this.GetMusicMenu().state;

        if (currentMusicSoundFile) {
            console.log(`[Music] Unducking`);
            currentMusicSoundFile.FadeIn(0.3, 1, 600);
        }
    }

    private async GetNextSongFileInfo(): Promise<B2FileInfo | undefined> {
        let cachedB2FileInfos = this.GetMusicMenu().state.cachedB2FileInfos;

        if (!cachedB2FileInfos) {
            cachedB2FileInfos = await this.GetReloadedCachedFileInfos();
        }

        const { selectedPlaylists } = this.GetMusicMenu().state;

        if (!selectedPlaylists) {
            const nextSongFileInfo = cachedB2FileInfos!.TakeOne();
            return nextSongFileInfo;
        }

        let nextSongFileInfo;
        let isMatchingSelectedPlaylist = false;

        while (!isMatchingSelectedPlaylist) {
            nextSongFileInfo = cachedB2FileInfos!.TakeOne();

            isMatchingSelectedPlaylist = selectedPlaylists.includes(
                nextSongFileInfo.playlistName
            );
        }

        return nextSongFileInfo;
    }

    private async GetReloadedCachedFileInfos() {
        const fileUrls: string[] = await Data.LoadFromServer(`files/music`);

        let b2fileInfos = fileUrls.map((fileUrl) => new B2FileInfo(fileUrl));

        const cachedB2FileInfos = new NonRepeatingShuffledArray(b2fileInfos);

        this.GetMusicMenu().setState({
            allFileInfos: b2fileInfos,
            cachedB2FileInfos,
        });

        return cachedB2FileInfos;
    }

    private GetMusicMenu = () =>
        State.ReadClass<IMusicMenuState>(ESharedComponent.MusicMenu);
}

export default new Music();
